<template>

    <div id="cloud-plan" class="cloud-plan" >
        <template v-if="!isApp">
            <cloud-intro />
            <ai-intro/>
        </template>
        <template v-else>
            <app-cloud-carousel/>
        </template>
        <h3 class="title" id="join">{{ $t('homepage.compatibility.title') }}</h3>
        <div class="plans-select">
            <PlanSubscribeSection
                @subscribe="selectPlanProduct"
                :productsArgs="{
                    legacy: '',
                    page: 'subscribe'
                }"
                :from="'cloud-plan'"
                confirmGaLabel="Cloud Storage Service-next"
                :filter-model-groups="filterModelGroups"
                :skip-device-selection="hasPendingBindDevice"
            />
        </div>
        <HowToUseCloud />
        <E2EEIntro v-if="!isApp"/>
        <faqs/>
    </div>

</template>

<script lang="ts">
import Vue from 'vue';
import faqs from './components/faqs.vue';
import AiIntro from './components/AiIntro.vue';
import CloudIntro from './components/CloudIntro.vue';
import E2EEIntro from './components/E2EEIntro.vue';
import PlanSubscribeSection from '@/components/PlanSubscribeSection/index.vue';
import AppCloudCarousel from './components/AppCloudCarousel.vue';
import HowToUseCloud from './components/HowToUseCloud.vue';
import { isApp } from '@/utils/business';
import { ISubscribeArgsWithDeviceInfo } from '@/components/PlanSubscribeSection/lib/types';
import reolinkGa from '@/common/js/gtagPageview';
import user from '@/api/user';
import { ESubscribeMode } from '@/interface';
import { getQueryParam, unitTransfer } from '@/common/js/utils';
import { mapGetters } from 'vuex';

export default Vue.extend({
    components: {

        faqs,
        AiIntro,
        CloudIntro,
        E2EEIntro,
        PlanSubscribeSection,
        AppCloudCarousel,
        HowToUseCloud

    },
    data () {

        return {
            gtagData: {} as Record<string, unknown>,
            args: {} as ISubscribeArgsWithDeviceInfo,

        };

    },
    computed:{
        ...mapGetters( ['isLogin'] ),
        isApp(): boolean {

            return isApp;

        },
        verified (): boolean {

            return this.$store.state.user.user.email.status === 'verified';

        },
        filterModelGroups(): Set<string> | undefined {

            const list = getQueryParam( this.$route, 'model_group' );
            if ( !list.length ) return undefined;
            return new Set( list.map( s => s.trim()).filter( Boolean ));

        },
        hasPendingBindDevice(): boolean {

            return getQueryParam( this.$route, 'pending_bind_device' ).length > 0;

        },
    },
    methods: {
        async selectPlanProduct ( args: ISubscribeArgsWithDeviceInfo ): Promise<void> {

            const { plan, series } = args;
            this.args = args;

            let itemListName = `(cloud-Plan)storageRegion:${series.storageRegion};deviceGroup:${series.deviceGroup}`;
            let name = series.i18n.name;
            name += `(${plan.duration.amount}-${plan.duration.unit})`;
            name += `(${plan.style['cloud_storage.video_lifetime'] ?? 0}-days,${plan.style['cloud_storage.max_device_quantity'] ?? 0}-cams,${unitTransfer( plan.style['cloud_storage.space_capacity'] ?? 0 )}${unitTransfer( plan.style['cloud_storage.space_capacity'] ?? 0, 'unit' )})`;

            let eventData = {
                items: [{
                    item_id: plan.id,
                    item_name: `(cloud-Plan)${name}`,
                    item_category: 'cloud-Plan',
                    price: Number( plan.pricing.salePrice ),
                    item_list_name: itemListName,
                    item_variant: `mode:create;currency:${plan.pricing.currency}`
                }]
            };
            this.gtagData = eventData;
            await this.subscribe( );

        },
        async subscribe ( ): Promise<void> {

            if ( this.isLogin ) {

                await user.getUserInfo();

            }
            await this.goCheckout(  );

        },
        async goCheckout ( ): Promise<void> {

            reolinkGa.sendECommerceEvent( 'select_item', this.gtagData );
            const query: Record<string, string | string[]> = {

                p_id: this.args.plan.id,
                selected_devices: this.args.selectedDevicesURL,
                mode: ESubscribeMode.CREATE,
                subNew: '1'

            };
            if ( !this.isLogin ) {

                await user.goToAccountCenter( true );
                return;

            }
            await this.$router.push({

                path: '/checkout/',
                query

            });

        }
    }

});

</script>

<style rel="stylesheet/css" lang="less" scoped>

</style>

<style scoped rel="stylesheet/css" lang="less">

.cloud-plan{
    background-color: @bg_01;

}
:target:before,
.hash-target{
    display: block;
    height: 1.5rem;
    margin: -1.5rem 0 0;
    cursor: auto;
}

.unique-plan {
    background-color: #F7F8F9;
    padding: 0 .6rem .4rem;
    max-width: 12rem;
    margin:0 auto;
    box-sizing: border-box;
    @media @pc{
        padding-top: .3rem;
    }
}

.basic-plan{
    max-width: 12rem;
    margin:0 auto;
    box-sizing: border-box;
    padding-top: 16px;
    @media @mobile{
        padding-top: 20px;
    }
}

.plans-select{
    margin: 0 auto;
    max-width: 1000px;
    box-sizing: border-box;
    margin-bottom: 80px;
    .mobile({
        .mobileMaxWidth();
        padding-bottom: 24px;
    });

    .titleBox{

        .notice-for-free{
            padding-top: 0.1rem;
            color:#333333;
            font-size: .16rem;
            line-height: 1.4;
            .des{
                margin-top: 0.08rem;
                display: block;
            }
            @media @mobile{
                padding: 0 20px;
                // margin-bottom:.32rem;
                text-align: left;
                margin: 0;
            }
        }
    }
    /deep/ .comp-basic-plan{
        background-color: @bg_02;
    }
    .legacy_tip_container{
        font-size: 18px;
        @media @pc{
            margin-bottom:24px;
        }
        @media @mobile{
            font-size: 14px;
            margin-bottom:20px;
        }
        .legacy_tip{
            padding: 14px 20px;
            text-align: left;
            background: @b_1;
            border-radius: 16px;
            display: flex;
            .icon-icon-hint-warning{
                color:#C15400;
                @media @pc{
                    font-size: .3rem;
                }
            }
            .tip_content{
                color:#333;
                font-weight: 500;
                margin-left:.2rem;
                /deep/ .support-link{
                    font-weight: 500;
                    color: @b_6;
                    cursor: pointer;
                    text-decoration: underline;
                    text-decoration-thickness:1px;
                }
                /deep/ a{
                    font-weight: 500;
                }
            }

        }

    }
    /deep/ .country-text, /deep/ .global-promotion-text{
        font-size: 14px;
        color: #FF894A;
        font-weight: 600;
        text-align: center !important;
        @media @pc{
            margin-bottom:24px;
        }
        @media @mobile{
            margin-bottom:20px;
        }
    }
}

.plan-content{
    @media @pc{
        &.pc{
            .subscription-button{
                margin: 0 auto;
                margin-top: 40px;
            }
        }
    }
    @media @mobile{
        display: block;
        padding: 0;
        .subscription-button-mobile{
            text-align: center;
            position: fixed;
            bottom: 0;
            left: 0;
            z-index: 3;
            width: 100%;
            /deep/ .reo-button-inner{
                border-radius: 0;
            }
        }
    }

}

.bottom-wrapper{
    display: flex;
    flex-direction: column;
    padding-top: 24px;
    .mobile({
        padding-top: 20px;
    });

    .plan-bottom{
        padding-top: 16px;
        margin-top: 16px;
        border-top: 1px solid @line;

        @media @mobile{
            text-align: left;
            padding-top: 12px;
            margin-top: 20px;
        }
    }
}

.show-basic-plan-container{
    width: 100%;
    text-align: left;
    margin-top: 0;
    line-break: 1.2;
    @media @mobile{
        width: unset;
    }

    .showBasicBtn{
        font-weight: 500;
        font-size: .16rem;
        @media @mobile{
            font-size:16px;
        }
        color:#333;
        cursor: pointer;
        span:last-child{
            margin-left: 8px;
        }
    }

}

#sub-part{
    margin:0 auto;
    @media @pc{
        max-width: 1000px;
    }
}

.buttons{
    display: flex;
    justify-content: center;
}

.title{
    color: #333;
    font-size: 42px;
    line-height: 1.2;
    padding-top: 80px;
    margin-bottom: 24px;
    text-align: center;
    font-weight: 600;
    .mobile({
        font-size: 28px;
        padding-top: 32px;
        margin-bottom: 12px;
    })
}
.cloud-plan /deep/ .single-card{
    margin: 0 auto;
}

</style>
